import {useCallback, useEffect, useRef} from 'react';
import {useReportStore} from '../../../../features/products/useReportStore';

export function useMarginRailActive({active, activeReferenceUid, view, onClear}) {
    const railRef = useRef(null);

    const setActiveReferenceMarkerId = useReportStore(s => s.setActiveReferenceMarkerId);

    const clearActive = useCallback(() => {
        onClear?.();
    }, [onClear]);

    useEffect(() => {
        if (!active) return;

        const onPointerDown = (e) => {
            const railEl = railRef.current;
            if (!railEl) return;
            if (railEl.contains(e.target)) return;
            if (view?.dom && view.dom.contains(e.target)) return;
            // MUI Menu/Select/Autocomplete popovers (e.g. the "Find (U) alternative" suggestion
            // menu) render via a portal into document.body, outside both the rail and the editor
            // DOM. Without this check, clicking a menu item registered as an "outside click" here
            // first — clearing the active marker (and unmounting the menu) before the item's own
            // onClick could ever fire, so the action silently no-op'd.
            if (e.target.closest?.('.MuiPopover-root, .MuiModal-root')) return;
            clearActive();
        };

        document.addEventListener('pointerdown', onPointerDown, true);
        return () => document.removeEventListener('pointerdown', onPointerDown, true);
    }, [active, clearActive, view]);

    useEffect(() => {
        setActiveReferenceMarkerId(activeReferenceUid ?? null);

        return undefined;
    }, [activeReferenceUid, setActiveReferenceMarkerId]);

    useEffect(() => {
        return () => {
            setActiveReferenceMarkerId(null);
        };
    }, [setActiveReferenceMarkerId]);

    return {railRef, clearActive};
}
